import { Tooltip } from '@mui/material';

export const truncateString = (str, charLength, name, spanStyle = {}) => {
  const defaultStyle = { fontSize: '14px', textTransform: 'capitalize' };
  const mergedStyle = { ...defaultStyle, ...spanStyle };

  if (!str) return <span style={mergedStyle}>{name || ''}</span>;

  if (str.length <= charLength) {
    return <span style={mergedStyle}>{str}</span>;
  }

  const newString = str.substring(0, charLength) + '...';

  return (
    <Tooltip title={str} placement="left" arrow>
      <span style={mergedStyle}>{newString.toLowerCase()}</span>
    </Tooltip>
  );
};
